import * as React from 'react';
import { connect } from 'react-redux'; // Connecting to Redux
import { Layout, Menu, Icon, message } from 'antd';
import { NavLink, Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import { ReduxStoreModel } from '../../redux/ReduxModel';
import { Roles, RoleConfig } from "src/constants/Roles";
import { UserState } from 'src/redux/UserReducer';
import '../SideNav.less';

const { Sider } = Layout;

interface RouteConfig {
    route: string;
    iconClass: string;
    text: React.ReactNode;
    subConfigs?: RouteConfig[];
}

interface AdminSideNavProps extends RouteComponentProps<{}> {
    // From Redux
    User: UserState;
}

interface AdminSideNavState {
    selectedKey: string;
    openKeys?: string[];
}

class AdminSideNav extends React.Component<AdminSideNavProps, AdminSideNavState> {
    private kuderAdminMenuConfig: RouteConfig[] = [
        { route: Routes.ADMIN_CLIENTS,                          iconClass: "fas fa-users",              text: <Translate id="admin.sideNav.clientsText" /> },
        { route: Routes.getRoute(Routes.ADMIN_USERS, true),     iconClass: "far fa-id-badge",           text: <Translate id="admin.sideNav.adminsText" /> },
        { route: Routes.ADMIN_UNIVERSAL_USER_SEARCH,            iconClass: "fas fa-fingerprint",        text: "Universal User Search" },

        { route: Routes.ADMIN_REPORTS,                          iconClass: "fas fa-scroll",             text: "Reports", subConfigs: [
            { route: Routes.ADMIN_REPORTS,                          iconClass: "fas fa-scroll",         text: <Translate id="admin.sideNav.reportsText" /> },
            // { route: Routes.ADMIN_REPORT_STUDENT_ACTIVITY_DETAIL,   iconClass: "fas fa-chart-bar",      text: <Translate id="admin.sideNav.activityDetailReport" /> },
        ]},

        { route: Routes.ADMIN_MATCHMAKER,                       iconClass: "fas fa-file-alt",           text: <Translate id="admin.sideNav.matchmakerText" /> },
        { route: Routes.ADMIN_SYNC_MATCHMAKER_DATA,             iconClass: "fas fa-sync-alt",           text: <Translate id="admin.sideNav.syncMatchmakerDataText" /> },
        { route: Routes.ADMIN_SYNC_MANAGEMENT,                  iconClass: "fas fa-sync",               text: <Translate id="admin.syncManagement.pageTitle" /> },
        { route: Routes.ADMIN_ACTIVITIES,                       iconClass: "fas fa-pencil-alt",         text: <Translate id="admin.sideNav.activitiesText" /> },
        { route: Routes.ADMIN_STATEMENTS,                       iconClass: "fas fa-comment-dots",       text: <Translate id="admin.sideNav.iStatementsText" /> },
        { route: Routes.GAME_HOME,                              iconClass: "fab fa-nintendo-switch",    text: "Game Home" },

        { route: Routes.ADMIN_STUDENT_VIEWS,                    iconClass: "fas fa-binoculars",       text: <Translate id="admin.studentViews.header" /> },
        { route: Routes.ADMIN_RESOURCES,                        iconClass: "far fa-copy",               text: <Translate id="admin.resources.header" /> },
        { route: Routes.ADMIN_LESSON_PLANS,                     iconClass: "far fa-copy",               text: <Translate id="admin.lessonPlans.title" /> },
        { route: Routes.ADMIN_HOLLAND_AREAS_GUIDE,              iconClass: "far fa-id-card",            text: <Translate id="common.hollandAreas" /> },
        { route: Routes.ADMIN_OCCUPATIONDB,                     iconClass: "far fa-id-card",            text: <Translate id="public.occupationdb.title" /> }
    ];
    private stateAdminMenuConfig: RouteConfig[] = [
        { route: Routes.ADMIN_DISTRICTS,                        iconClass: "fas fa-network-wired",    text: <Translate id="admin.sideNav.districtsText" /> },
        { route: Routes.getRoute(Routes.ADMIN_USERS, true),     iconClass: "far fa-id-badge",         text: <Translate id="admin.sideNav.adminsText" /> },

        { route: Routes.ADMIN_ACADEMICS,                        iconClass: "fas fa-graduation-cap",   text: <Translate id="admin.sideNav.academicsText" /> },
        { route: Routes.ADMIN_STATEMENTS,                       iconClass: "fas fa-comment-dots",     text: <Translate id="admin.sideNav.iStatementsText" /> },

        { route: Routes.ADMIN_STUDENT_VIEWS,                    iconClass: "fas fa-binoculars",       text: <Translate id="admin.studentViews.header" /> },
        { route: Routes.ADMIN_RESOURCES,                        iconClass: "far fa-copy",             text: <Translate id="admin.resources.header" /> },
        { route: Routes.ADMIN_LESSON_PLANS,                     iconClass: "far fa-copy",             text: <Translate id="admin.lessonPlans.title" /> },
        { route: Routes.ADMIN_HOLLAND_AREAS_GUIDE,              iconClass: "far fa-id-card",          text: <Translate id="common.hollandAreas" /> },
        { route: Routes.ADMIN_OCCUPATIONDB,                     iconClass: "far fa-id-card",          text: <Translate id="public.occupationdb.title" /> }
    ];
    private districtAdminMenuConfig: RouteConfig[] = [
        { route: Routes.ADMIN_SCHOOLS,                          iconClass: "fas fa-school",           text: <Translate id="admin.sideNav.schoolsText" /> },
        { route: Routes.getRoute(Routes.ADMIN_USERS, true),     iconClass: "far fa-id-badge",         text: <Translate id="admin.sideNav.adminsText" /> },
        { route: Routes.getRoute(Routes.ADMIN_USERS, false),    iconClass: "fas fa-child",            text: <Translate id="admin.sideNav.studentsText" /> },

        { route: Routes.ADMIN_REPORTS,                          iconClass: "fas fa-scroll",         text: "Reports", subConfigs: [
            { route: Routes.ADMIN_REPORT_SUPERINTENDENT,            iconClass: "fas fa-file-alt",       text: <Translate id="admin.sideNav.superintendentReport" /> },
            // Dev Note: Removed for now till get a specific district admin report
            // { route: Routes.ADMIN_REPORT_STUDENT_PLANET_COMPLETION, iconClass: "fas fa-globe",          text: <Translate id="admin.sideNav.completionReport" /> },
        ]},

        { route: Routes.ADMIN_ACADEMICS,                        iconClass: "fas fa-graduation-cap",   text: <Translate id="admin.sideNav.academicsText" /> },
        { route: Routes.ADMIN_STATEMENTS,                       iconClass: "fas fa-comment-dots",     text: <Translate id="admin.sideNav.iStatementsText" /> },

        { route: Routes.ADMIN_STUDENT_VIEWS,                    iconClass: "fas fa-binoculars",       text: <Translate id="admin.studentViews.header" /> },
        { route: Routes.ADMIN_RESOURCES,                        iconClass: "far fa-copy",             text: <Translate id="admin.resources.header" /> },
        { route: Routes.ADMIN_LESSON_PLANS,                     iconClass: "far fa-copy",             text: <Translate id="admin.lessonPlans.title" /> },
        { route: Routes.ADMIN_HOLLAND_AREAS_GUIDE,              iconClass: "far fa-id-card",          text: <Translate id="common.hollandAreas" /> },
        { route: Routes.ADMIN_OCCUPATIONDB,                     iconClass: "far fa-id-card",          text: <Translate id="public.occupationdb.title" /> }
    ];
    private schoolAdminMenuConfig: RouteConfig[] = [
        { route: Routes.ADMIN_CLASSROOMS,                       iconClass: "fas fa-bell",           text: <Translate id="admin.sideNav.classroomsText" /> },
        { route: Routes.getRoute(Routes.ADMIN_USERS, true),     iconClass: "far fa-id-badge",       text: <Translate id="admin.sideNav.adminsText" /> },
        { route: Routes.getRoute(Routes.ADMIN_USERS, false),    iconClass: "fas fa-child",          text: <Translate id="admin.sideNav.studentsText" /> },

        { route: Routes.ADMIN_REPORTS,                          iconClass: "fas fa-scroll",         text: "Reports", subConfigs: [
            { route: Routes.ADMIN_REPORT_PRINCIPAL,                 iconClass: "fas fa-file-alt",       text: <Translate id="admin.sideNav.principalReport" /> },
            { route: Routes.ADMIN_REPORT_STUDENT_ACTIVITY_DETAIL,   iconClass: "fas fa-chart-bar",      text: <Translate id="admin.sideNav.activityDetailReport" /> },
            { route: Routes.ADMIN_REPORT_STUDENT_PLANET_COMPLETION, iconClass: "fas fa-globe",          text: <Translate id="admin.sideNav.planetCompletionReport" /> },
            { route: Routes.ADMIN_REPORT_STUDENT_GAME_COMPLETION,   iconClass: "fas fa-gamepad",        text: <Translate id="admin.sideNav.gameCompletionReport" /> },
            { route: Routes.ADMIN_REPORT_STUDENT_STATEMENT,         iconClass: "fas fa-info",           text: <Translate id="admin.sideNav.statementReport" /> },
        ]},

        { route: Routes.ADMIN_ACADEMICS,                        iconClass: "fas fa-graduation-cap", text: <Translate id="admin.sideNav.academicsText" /> },
        { route: Routes.ADMIN_STATEMENTS,                       iconClass: "fas fa-comment-dots",   text: <Translate id="admin.sideNav.iStatementsText" /> },

        { route: Routes.ADMIN_STUDENT_VIEWS,                    iconClass: "fas fa-binoculars",     text: <Translate id="admin.studentViews.header" /> },
        { route: Routes.ADMIN_RESOURCES,                        iconClass: "far fa-copy",           text: <Translate id="admin.resources.header" /> },
        { route: Routes.ADMIN_LESSON_PLANS,                     iconClass: "far fa-copy",           text: <Translate id="admin.lessonPlans.title" /> },
        { route: Routes.ADMIN_HOLLAND_AREAS_GUIDE,              iconClass: "far fa-id-card",        text: <Translate id="common.hollandAreas" /> },
        { route: Routes.ADMIN_OCCUPATIONDB,                     iconClass: "far fa-id-card",        text: <Translate id="public.occupationdb.title" /> }
    ];
    private teacherCounselorAdminMenuConfig: RouteConfig[] = [
        { route: Routes.ADMIN_CLASSROOMS,                       iconClass: "fas fa-bell",             text: <Translate id="admin.sideNav.classroomsText" /> },
        { route: Routes.getRoute(Routes.ADMIN_USERS, false),    iconClass: "fas fa-child",            text: <Translate id="admin.sideNav.studentsText" /> },

        { route: Routes.ADMIN_STUDENT_VIEWS,                    iconClass: "fas fa-binoculars",       text: <Translate id="admin.studentViews.header" /> },
        { route: Routes.ADMIN_RESOURCES,                        iconClass: "far fa-copy",             text: <Translate id="admin.resources.header" /> },
        { route: Routes.ADMIN_LESSON_PLANS,                     iconClass: "far fa-copy",             text: <Translate id="admin.lessonPlans.title" /> },
        { route: Routes.ADMIN_HOLLAND_AREAS_GUIDE,              iconClass: "far fa-id-card",          text: <Translate id="common.hollandAreas" /> },
        { route: Routes.ADMIN_OCCUPATIONDB,                     iconClass: "far fa-id-card",          text: <Translate id="public.occupationdb.title" /> }
    ];

    constructor(props: AdminSideNavProps) {
        super(props);
        bindAllOfThis(this, AdminSideNav.prototype);

        this.state = {
            selectedKey: "home"
        };
    }

    componentWillMount() {
        let role = Roles.FindById(this.props.User.roleID);
        let { pathname } = this.props.location;
        this.coolUpdate(role, pathname);
    }

    private findRouteConfig(routeConfigs: RouteConfig[], route: string) {
        let getRouteRecursive = (route: string, routeConfigs: RouteConfig[]): { selectedKey: string, openKeys: string[] } => {
            for (const routeConfig of routeConfigs) {
                if (routeConfig.subConfigs?.length > 0) {
                    let q = getRouteRecursive(route, routeConfig.subConfigs);
                    if (q != null) {
                        return { selectedKey: q.selectedKey, openKeys: [routeConfig.route, ...q.openKeys] };
                    }
                }
                if (routeConfig.route?.toLowerCase() === route.toLowerCase()) {
                    return { selectedKey: routeConfig.route, openKeys: [] };
                }
            }
            return null;
        };

        return getRouteRecursive(route, routeConfigs);
    }

    private getConfigByRole(role: RoleConfig) {
        switch (role) {
            case Roles.KuderAdmin:
                return { menuConfigs: this.kuderAdminMenuConfig, defaultRoute: Routes.ADMIN_CLIENTS };
            case Roles.StateAdmin:
                return { menuConfigs: this.stateAdminMenuConfig, defaultRoute: Routes.ADMIN_DISTRICTS };
            case Roles.DistrictAdmin:
                return { menuConfigs: this.districtAdminMenuConfig, defaultRoute: Routes.ADMIN_SCHOOLS };
            case Roles.SchoolAdmin:
                return { menuConfigs: this.schoolAdminMenuConfig, defaultRoute: Routes.getRoute(Routes.ADMIN_USERS, true) };
            case Roles.TeacherCounselorAdmin:
                return { menuConfigs: this.teacherCounselorAdminMenuConfig, defaultRoute: Routes.ADMIN_CLASSROOMS };
            default:
                console.error(`Invalid role "${role?.name || "unknown"}".`);
                return null;
        }
    }

    private coolUpdate(role: RoleConfig, route?: string) {
        let configByRoute = this.getConfigByRole(role);
        let routeConfig = this.findRouteConfig(configByRoute.menuConfigs, route || configByRoute.defaultRoute);

        // Update the selection
        this.setState({ ...routeConfig });
    }

    private updateSelection(selectedKey: string) {
        let role = Roles.FindById(this.props.User.roleID);
        this.coolUpdate(role, selectedKey);
    }

    private renderHome(): JSX.Element {
        return <Menu.Item key={Routes.BASE_ROUTE}>
            <label className="screen-reader-hidden" htmlFor="home"><Translate id="common.home" /></label>
            <NavLink to={Routes.BASE_ROUTE}>
                <div id="home" className="fas fa-home" aria-label="Home" /> <Translate id="common.home" />
            </NavLink>
        </Menu.Item>;
    }

    private renderContactUs(): JSX.Element {
        return <Menu.Item key="contact">
            <a href="http://kuder.com/contact-us">
                <div className="far fa-address-book" /><Translate id="public.footer.contact" />
            </a>
        </Menu.Item>;
    }

    private renderMenuItems(routeConfig: RouteConfig) {
        if (routeConfig.subConfigs?.length > 0) {
            return <Menu.SubMenu
                key={routeConfig.route}
                title={<React.Fragment><div className={routeConfig.iconClass} /> {routeConfig.text}</React.Fragment>}
            >
                {routeConfig.subConfigs.map(subConfig => (this.renderMenuItems(subConfig)))}
            </Menu.SubMenu>;
        }

        return <Menu.Item key={routeConfig.route}>
            <NavLink to={routeConfig.route}>
                <div className={routeConfig.iconClass} /> {routeConfig.text}
            </NavLink>
        </Menu.Item>;
    }

    public render() {
        let role = Roles.FindById(this.props.User.roleID);
        let config = this.getConfigByRole(role);
        let elements = config.menuConfigs.map(x => (this.renderMenuItems(x)));

        return <Sider
            width="328px"
            breakpoint="md"
            collapsedWidth="0"
            className="side-nav"
        >
            <Menu mode="inline"
                onSelect={param => this.updateSelection(param.key)}
                selectedKeys={[this.state.selectedKey]}
                defaultOpenKeys={this.state.openKeys}
            >
                {this.renderHome()}
                {elements}
                {this.renderContactUs()}
            </Menu>
        </Sider>;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User
    };
}

export default connect(mapStateToProps)(withRouter(AdminSideNav));



// WEBPACK FOOTER //
// ./src/layouts/admin/AdminSideNav.tsx